import React from "react";

import { useAlerts } from "../services/Alerts/AlertHooks";

import { useRedirectToMap } from '../components/Map/useRedirectToMap';

import AlarmList from "../components/AlarmList/AlarmList";
import DeviceDetails from "../components/DeviceDetails/DeviceDetails";
import PageHeader, { usePageHeaderState } from "./commons/PageHeader";

import AlarmFilter from "../components/FilterComponents/AlarmFilter";

import "./viewBody.scss";
import './layout.scss';


export default function AlarmsView(props) {
   

    const [alerts] = useAlerts(true);

    useRedirectToMap(props);

    const [filters, sorters, searchKey, updateAlterState, filteredItems] = usePageHeaderState({
        filters: [
            {
                key: "state",
                rule: "IS",
                value: "ACTIVE",
            },
        ],
        sorters: [],
        search: "",
        searchFromKeys: ["device_Id", "device_Code", "description", "type", "source"],
        items: alerts,
    });


    const totalCount = Array.isArray(alerts) ? alerts.filter(alert => alert.state === "ACTIVE").length : 0;

    // console.log("RENDER ACTIVE ALARMS", totalCount, alerts !== null ? alerts.length : null, alerts);
    return (
        <div className="main-view">
            <PageHeader
                permissions={props.permissions}
                title="Active alarms"
                disableSorter={true}
                filters={filters}
                sorters={sorters}
                search={searchKey}
                searchDisabled={totalCount === 0}
                onChange={updateAlterState}
                filterComponent={AlarmFilter}
                alarmSettings={props.permissions.includes('deviceManagement')}
            />
            
            <div className="view-body alarms-view">
                <div className="body-list">
                    <AlarmList filter="ACTIVE" alerts={filteredItems} totalCount={totalCount} />
                </div>
                {<DeviceDetails permissions={props.permissions}/>}
            </div>
        </div>
    );
}
